import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "../../../services/store.service";
import { ServiceControllerService } from "../../../services/service-controller/service-controller.service";

@Component({
  selector: "app-service-manage",
  templateUrl: "./service-manage.component.html",
})
export class ServiceManageComponent implements OnInit {

  public serviceId: string;
  public currentRoute: string;
  public tabsType: string =  "tabs";
  public defaultMyAccountServiceId: string;
  @Input() public showPublish = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private serviceControllerService: ServiceControllerService,
    private router: Router,
    public store: Store,
  ) { }

  public ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.serviceId = (params.serviceId === "new") ? null : params.serviceId;
      this.serviceControllerService.getMyAccountService().subscribe((data) => {
        this.defaultMyAccountServiceId = data.id;
        this.store.state.common.defaultMyAccountServiceId = this.defaultMyAccountServiceId;
      });
    });
    this.activatedRoute.url.subscribe(() => {
      this.currentRoute = this.activatedRoute.snapshot.firstChild.routeConfig.path;
    });
  }

  public ngAfterViewInit(): void {
    this.initTabs();
  }

  public initTabs(): void {
    const container = document.getElementById("tabsContainer");
    const tabs = document.getElementById("tabsList");
    const tabsResp = document.getElementById("tabsResp");
    container.classList.remove("d-none");
    tabs.classList.add("loading");
    tabs.classList.remove("d-none");
    tabsResp.classList.add("loading");
    tabs.classList.remove("d-none");
    tabsResp.classList.remove("d-none");
    if (container && tabs) {
      tabs.classList.remove("loading");
      tabsResp.classList.remove("loading");
      if (Number(container.getBoundingClientRect().width) <= (tabs.getBoundingClientRect().width)) {
        tabsResp.classList.remove("d-none");
        tabs.classList.add("d-none");
        this.tabsType = "tabs";
      } else {
        this.tabsType = "dropdown";
        tabs.classList.remove("d-none");
        tabsResp.classList.add("d-none");
      }
    }
  }

  public onResize(event) {
    this.initTabs();
  }

  public navigateRoute(route: string): void {
    this.router.navigate(["/services/" + this.serviceId + "/settings/" + route]);
  }
}
